import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from 'styles/theme';

const Spinner: React.FC = () => (
  <Wrapper>
    <StyledSpinner>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </StyledSpinner>
  </Wrapper>
);

export default Spinner;

const animation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
  display: flex;
  height: 100dvh;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const StyledSpinner = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid ${theme.colors.remondis_accent};
    border-radius: 50%;
    animation: ${animation} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${theme.colors.remondis_accent} transparent transparent transparent;
  }

  div:nth-child(1) {
    animation-delay: -0.45s;
  }

  div:nth-child(2) {
    animation-delay: -0.3s;
  }

  div:nth-child(3) {
    animation-delay: -0.15s;
  }
`;
